import { useQuery } from "@tanstack/react-query";
import { connect } from "../../api-core";
import { useCookies } from "react-cookie";
import { cookiesNameStatic } from "../../../common/statics/cookiesNameStatic";
import { navigate } from "gatsby";
import { useEffect } from "react";
import { performLogout } from "../../../utils/authHelper";

async function fetchStoreInfo() {
  return await connect(true).get("v1/TC/dashboard/settings");
}

export default function UseFetchStoreInfoQuery() {
  const [cookie, setCookie, removeCookie] = useCookies();
  const query = useQuery({
    queryKey: ["storeInfo-" + cookie[cookiesNameStatic.USER_IDENTIFIER]],
    queryFn: fetchStoreInfo,
  });
  useEffect(() => {
    if (query?.isSuccess) {
      const limitation = query?.data?.data?.limitation;
      const storeId = query?.data?.data?.storeId;
      if (limitation?.isUninstalled && storeId !== "0") {
        performLogout();
      }
    }
  }, [query.isSuccess]);

  return query;
}
